export default __webpack_public_path__ + "static/media/Genome_Expo_2022_scientist_icon.a504d404.png";